import React from 'react';
import { BreadcrumbsStyles as S } from './Breadcrumbs.styles';
import Chevron from '@img/icons/thick-chevron.svg';
const Breadcrumbs = ({ links, theme }) => {
    return (React.createElement(S.Wrapper, { "data-theme": theme },
        React.createElement(S.Container, null, links.map((link, i) => (React.createElement(S.NavItem, { key: `Breadcrumbs_Link_${i}` },
            i === links.length - 1 ? (React.createElement("span", null, link.text)) : (React.createElement("a", { role: "link", target: link.target, href: link.url }, link.text)),
            i < links.length - 1 && React.createElement(Chevron, null)))))));
};
export default Breadcrumbs;
